import { useEffect } from 'react';
import { useIdle } from 'react-use';
import { useReportUserPresenceFromDashboardShellMutation } from '../generated/graphql';
import { useThrottledCallback } from '@robinpowered/dashboard-apps-common';

const PRESENCE_CHECK_INTERVAL = 60 * 60_000; // 1 hour.

export const usePresenceNotifier = ({
  activeOrgId,
}: {
  activeOrgId: string | null;
}): void => {
  const [reportPresence] = useReportUserPresenceFromDashboardShellMutation();
  const isIdle = useIdle(PRESENCE_CHECK_INTERVAL, false);

  const throttledPresence = useThrottledCallback(
    () => {
      fetch('https://api.seeip.org/jsonip', { credentials: 'omit' })
        .then((response) => response.json())
        .then(({ ip }) => ip)
        .catch((error) => {
          // eslint-disable-next-line no-console -- TODO: call sentry?
          console.error('Error fetching IP address', error);
          return null;
        })
        .then((ip) =>
          reportPresence({
            variables: {
              clientName: 'robin/web/dashboard',
              ipAddressGuess: ip,
            },
          })
        );
    },
    [activeOrgId, reportPresence],
    PRESENCE_CHECK_INTERVAL,
    {
      trailing: false,
      leading: true,
    }
  );

  useEffect(() => {
    if (!isIdle && activeOrgId) {
      throttledPresence();
    }
  }, [isIdle, throttledPresence, activeOrgId]);
};
